import { Fragment, useEffect, useRef, useState } from 'react';
// MUI
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import ButtonBase from '@mui/material/ButtonBase';
import styled from '@mui/material/styles/styled';
// CUSTOM COMPONENTS
import PopoverLayout from './PopoverLayout';
import FlexBox from 'components/flexbox/FlexBox';
import AvatarLoading from 'components/avatar-loading';
import { H6, Paragraph, Small } from 'components/typography';
// CUSTOM DEFINED HOOK
import useAuth from 'hooks/useAuth';
import useNavigate from 'hooks/useNavigate';
// CUSTOM UTILS METHOD
import { isDark } from 'utils/constants';
import { authLogout } from '../../../store/reducers/auth';
import { dispatch, useAppSelector } from '../../../store';
import {
  getOwnUser,
  getUserById
} from '../../../store/reducers/dashboard/usersReducer';
import permissionsAccess from '../../../utils/permissionsAccess';
import permissionsList from '../../../constants/permissionsList';
import { useAutoLogout } from '../../../hooks/useAutoLogout';
import { getOwnCompany } from '../../../store/reducers/admin/companyReducer';

// STYLED COMPONENTS
const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  marginLeft: 8,
  borderRadius: 30,
  border: `1px solid ${theme.palette.grey[isDark(theme) ? 800 : 200]}`,
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}));
const StyledSmall = styled(Paragraph)(({ theme }) => ({
  fontSize: 13,
  display: 'block',
  cursor: 'pointer',
  padding: '5px 1rem',
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}));
export default function ProfilePopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.users.currentUserInfo);
  const userInfo =
    sessionStorage.getItem('user') || localStorage.getItem('user');

  const { startAutoLogout } = useAutoLogout();

  // Function to get initials from user name
  const getInitials = (userName) => {
    if (!userName) return '';
    const names = userName.trim().split(/\s+/);
    if (names.length >= 2) {
      return (names[0][0] + names[names.length - 1][0]).toUpperCase();
    }
    return names[0].substring(0, 2).toUpperCase();
  };

  useEffect(() => {
    if (userInfo) {
      const parsedInfo = JSON.parse(userInfo);

      if (parsedInfo?.id) {
        dispatch(getOwnUser()).catch(() => {});
        dispatch(getOwnCompany()).catch(() => {});
      }
    }
  }, []);

  useEffect(() => {
    if (!user || !user.minimumInactiveTimeout) return;

    const timeoutMs = user.minimumInactiveTimeout * 60 * 1000;

    const cleanup = startAutoLogout(timeoutMs, () => {
      logout();
    });

    return cleanup;
  }, [user?.minimumInactiveTimeout]);

  const logout = () => {
    dispatch({ type: 'LOGOUT' });
    dispatch(authLogout());
  };
  const handleMenuItem = (path) => () => {
    navigate(path);
    setOpen(false);
  };

  const { role } = useAuth();
  let { read } = permissionsAccess(role, permissionsList.CompanyInfo);

  return (
    <Fragment>
      <StyledButtonBase ref={anchorRef} onClick={() => setOpen(true)}>
        <Avatar
          src={user?.image ? user?.image : ''}
          sx={{
            width: 35,
            height: 35,
            borderRadius: '50%'
          }}
        >
          {!user?.image && getInitials(user?.userName)}
        </Avatar>
      </StyledButtonBase>

      <PopoverLayout
        hiddenViewButton
        maxWidth={330}
        minWidth={200}
        popoverOpen={open}
        anchorRef={anchorRef}
        popoverClose={() => setOpen(false)}
        title={
          <FlexBox
            alignItems="center"
            gap={1}
            sx={{ cursor: 'pointer' }}
            onClick={handleMenuItem('/admin/user-info?tab=details')}
          >
            <Avatar
              src={user?.image ? user?.image : ''}
              sx={{
                width: 35,
                height: 35,
                borderRadius: '50%'
              }}
            >
              {!user?.image && getInitials(user?.userName)}
            </Avatar>

            <div>
              <H6 fontSize={14}>{user?.userName}</H6>
              <Small color="text.secondary" display="block">
                {user?.email}
              </Small>
            </div>
          </FlexBox>
        }
      >
        <Box pt={1}>
          {/*<StyledSmall onClick={handleMenuItem('/dashboard/profile')}>*/}
          {/*  Set Status*/}
          {/*</StyledSmall>*/}

          {/*<StyledSmall onClick={handleMenuItem('/dashboard/profile')}>*/}
          {/*  Profile & Account*/}
          {/*</StyledSmall>*/}

          {/*<StyledSmall onClick={handleMenuItem('/dashboard/account')}>*/}
          {/*  Settings*/}
          {/*</StyledSmall>*/}

          {/*<StyledSmall onClick={handleMenuItem('/dashboard/profile')}>*/}
          {/*  Manage Team*/}
          {/*</StyledSmall>*/}

          {/*<Divider*/}
          {/*  sx={{*/}
          {/*    my: 1*/}
          {/*  }}*/}
          {/*/>*/}
          {read && user && (
            <StyledSmall
              onClick={handleMenuItem(`/admin/company-info/${user?.companyId}`)}
            >
              Company Info
            </StyledSmall>
          )}

          <StyledSmall onClick={logout}>Sign Out</StyledSmall>
        </Box>
      </PopoverLayout>
    </Fragment>
  );
}
